import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

/**
 * A small social-typography widget for the AngelsGrid hero. Shows up to three
 * of the most recently *approved* attributes across the squad — each chip is
 * a quiet link to that angel's detail page so a curious newcomer can chase
 * the word back to the artwork that inspired it.
 *
 * Auto-hides on empty (no approved attributes yet), so the hero stays clean
 * on launch day and during quiet weeks.
 */
export default function SquadVoice() {
    const [items, setItems] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        let cancelled = false;
        api.get("/squad-voice")
            .then(({ data }) => {
                if (cancelled) return;
                setItems(data?.items || []);
            })
            .catch(() => { /* silent — widget hides */ })
            .finally(() => { if (!cancelled) setLoaded(true); });
        return () => { cancelled = true; };
    }, []);

    if (!loaded || items.length === 0) return null;

    return (
        <div
            className="mt-5 flex flex-wrap items-center gap-2"
            data-testid="grid-squad-voice"
            aria-label="Recent words from the squad"
        >
            <span className="font-label text-[9px] tracking-[0.3em] uppercase text-[#6e6a62] mr-1">
                The squad is saying
            </span>
            {items.map((it, idx) => (
                <Link
                    key={`${it.angelNumber}-${idx}`}
                    to={`/angels/${it.angelNumber}`}
                    data-testid={`grid-squad-voice-${it.angelNumber}`}
                    className="group inline-flex items-center gap-2 border border-white/10 hover:border-[#cfa052]/40 rounded-full px-3 py-1 font-poetic text-[12px] text-[#9a958a] hover:text-[#e8e4db] transition-colors duration-300"
                >
                    <span className="font-numerals text-[#cfa052] text-[11px] group-hover:text-[#e0b569] transition-colors">
                        {it.angelNumber}
                    </span>
                    <span className="opacity-50">·</span>
                    <span className="italic">{it.text}</span>
                </Link>
            ))}
        </div>
    );
}
